export const Article = require('../../src/core/Articles/Article').default;
